<template>
  <div>
    <PlanTemplate>
      <template slot="title">{{content.title}}</template>
      <template slot="english-title"
        >{{content.desc}}</template
      >
      <template slot="crumb">
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>解决方案</el-breadcrumb-item>
          <el-breadcrumb-item>慢病随访服务平台</el-breadcrumb-item>
        </el-breadcrumb> -->

        <div class="crumb-area">
          <div class="crumb-item index" @click="toPage()">首页</div>
          <div class="arrow">
            <img src="../../assets/img/icon/icon_xl2@2x.png" alt="" />
          </div>
          <div class="crumb-item">{{navList[1].title}}</div>
          <div class="arrow">
            <img src="../../assets/img/icon/icon_xl2@2x.png" alt="" />
          </div>
          <div class="crumb-item">{{content.title}}</div>
        </div>
      </template>
      <!-- <template slot="detail">
        为综合性医院及专科医院开发设计的慢病管理网络系统。以全面导入疾病管理的概念，针对常见慢性病的诊疗，帮助科室快速实现慢性病病历的系统管理，辅助医生护士的日常诊疗护理工作，并为医院向患者提供多样化诊疗服务创造条件。通过建立电子健康档案，实现远程监测-智能评价一个性干预-再监测-再评价-再干预，动态、长期、闭环的医养结合工作流程
      </template>
      <template slot="info">
        <img src="../../assets/img/plans/m1.png" alt="" />
      </template> -->
      <template slot="other">
        <div v-html="content.content">

        </div>
      </template>
    </PlanTemplate>
  </div>
</template>

<script>
import { solution, banner,setting } from "../../network/http_api";

import PlanTemplate from "../../components/planTemplate.vue";
export default {
  data() {
    return {
      id: "",
      banner: {},
      content: {},
       navList:[]
    };
  },
  components: {
    PlanTemplate,
  },
  mounted() {
    this.id = this.$route.query.item_id;
    this.getData();
    this.getNav()
    // this.getBanner();
  },
  watch: {
    $route(to, from) {
      //console.log(from); //从哪来
      //console.log(to); //到哪去
       this.id = this.$route.query.item_id;
      this.getData()
    },
  },
  methods: {
    async getNav() {
      let res = await setting();
      if (res.code == 200) {
        this.navList = JSON.parse(res.data.model_setting);
        //console.log("headers", this.navList);
      } else {
        this.$message.error(res.msg);
      }
    },
    async getBanner() {
      let res = await banner(3);
      if (res.code == 200) {
        this.banner = res.data[0];
        //console.log("banner", res.data);
      } else {
        this.$message.error(res.msg);
      }
      //console.log("banner", res);
    },
    toPage() {
      this.$bus.$emit("headerIdx", 0);

      this.$router.push("/");
            document.title = '首页';

    },
    async getData() {
      let res = await solution(this.id);
      //console.log("solution", res.data);
      if (res.code == 200) {
        this.content = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.crumb-area {
  display: flex;
  .crumb-item {
    color: #606266;
  }
  .index {
    cursor: pointer;
  }
  .index:hover {
    color: #1d7bff;
  }
  .arrow {
    width: 18px;
    margin: 0 8px;
    img {
      width: 100%;
    }
  }
}
</style>